import { c as _c } from "react/compiler-runtime";
import { mapTagsToGenres } from '@/constants/genre';
import { useGenreContext } from '@/context/GenreContext';
import { Link } from '@/i18n/navigation';
export default function AllGenresMobile() {
  const $ = _c(6);
  const {
    tags
  } = useGenreContext();
  let t0;
  let t1;
  if ($[0] !== tags) {
    const genres = mapTagsToGenres(tags);
    t0 = "grid grid-cols-3 gap-4 md:flex md:flex-1 md:flex-wrap md:gap-5";
    t1 = genres?.map(_temp);
    $[0] = tags;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <div className={t0}>{t1}</div>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(genre, index) {
  return <Link key={index} href={`/genre/${genre.name}`}><div className="group relative aspect-[108/133] w-full cursor-pointer overflow-hidden rounded-xl transition-all duration-300 hover:shadow-2xl md:w-[108px]"><div className="absolute inset-0 opacity-55" style={{
        background: genre.primaryGradient
      }} /><div className="absolute inset-0 opacity-20" style={{
        background: genre.overlayGradient
      }} /><div className="relative z-interactive flex h-full flex-col items-start gap-1 px-3 py-2"><h3 className="subheader-2 font-extrabold text-white drop-shadow-lg">{genre.title}</h3></div><div className="absolute right-[-90%] bottom-[-50%] opacity-100"><genre.Icon className="size-[157px] transition-all group-hover:scale-110 group-hover:opacity-100" /></div></div></Link>;
}